import {RESET_DATA_ABOUT_ADS, SET_USER_TYPE} from '../actions/ads';
import { SET_AFTER_LOGIN } from '../actions/ads';
import { RESET_AFTER_LOGIN } from '../actions/ads';
import { SET_PROPS } from '../actions/ads';
import { SET_CONTENT_DATA_PUBLICITY } from '../actions/ads';
import { SET_DATA_NEXT_EPISODE_ADS } from '../actions/ads';
import { SET_URL_ADS } from '../actions/ads';
import { SET_KIND_OF_PLAY_BUTTON_ADS } from '../actions/ads';
import { SET_MULTI_PBI_NEXT_EPISODE_ADS } from '../actions/ads';
import Constans from '../AAF/Ads/Constans';
const { ID_PRE_ROLL_BITMOVIN_SERVICE, ID_POST_ROLL_BITMOVIN_SERVICE } = Constans

const initialState = {
    userType: null,
    continueAfterLogin: false,
    urlAfterLogin: '',
    propsAfterLogin: {},
    props: {},
    currentContentType: '',
    publicity: 'false',
    rolls: {
      [ID_PRE_ROLL_BITMOVIN_SERVICE]: "false",
      [ID_POST_ROLL_BITMOVIN_SERVICE]: "false",
    },
    multiPbiNextEpisode: {},
    nextData: {},
    urlAds: '',
    playFreemiumButton: "0"
};

function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case SET_USER_TYPE:
            return {
                ...state,
                userType: action.payload,
            };
        case SET_AFTER_LOGIN:
            return {
                ...state,
                continueAfterLogin: true,
                urlAfterLogin: action.payload.urlAfterLogin,
                propsAfterLogin: action.payload.propsAfterLogin,

            };
        case SET_CONTENT_DATA_PUBLICITY:
            return {
                ...state,
                currentContentType: action.payload.currentContentType,
                publicity: action.payload.publicity,
                rolls: action.payload.rolls
            };
        case SET_MULTI_PBI_NEXT_EPISODE_ADS:
            return {
                ...state,
                multiPbiNextEpisode: action.payload
            };
        case SET_DATA_NEXT_EPISODE_ADS:
            return {
                ...state,
                nextData: action.payload
            };
        case SET_URL_ADS:
            return {
                ...state,
                urlAds: action.payload.url
            };
        case SET_KIND_OF_PLAY_BUTTON_ADS:
            return {
                ...state,
                playFreemiumButton: action.payload.playFreemiumButton.visible
            };
        case RESET_DATA_ABOUT_ADS:
          return {
            ...state,
            currentContentType: '',
            publicity: 'false',
            rolls: {
              [ID_PRE_ROLL_BITMOVIN_SERVICE]: "false",
              [ID_POST_ROLL_BITMOVIN_SERVICE]: "false",
            },
            multiPbiNextEpisode: {},
            nextData: {},
            urlAds: '',
            playFreemiumButton: "0"
          };
        case RESET_AFTER_LOGIN:
            return {
                ...state,
                continueAfterLogin: false,
                urlAfterLogin: '',
                propsAfterLogin: {}
            };
        case SET_PROPS:
            return {
                ...state,
                props: action.payload,
            }
        default:
            return state;
    }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/ads.js